import { TokenPlugin } from '@absis/core-plugins';

export const CBToken: TokenPlugin = {
  getToken: (): Promise<string | null> => {
    return Promise.resolve('');
  },
  revokeToken: (): Promise<void> => {
    return Promise.reject(
      new Error('CBToken.revokeToken() is not supported for Desktop devices')
    );
  },
};
